import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=329163fa&scoped=true&"
import script from "./Question.vue?vue&type=script&lang=js&"
export * from "./Question.vue?vue&type=script&lang=js&"
import style1 from "./Question.vue?vue&type=style&index=1&id=329163fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329163fa",
  null
  
)

export default component.exports